import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AbstractDynamicComponent } from '@components/abstracts';
import { Iframe } from '@components/iframe/models';

@Component({
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IframeComponent extends AbstractDynamicComponent<Iframe> implements OnInit {
  protected safeUrl: SafeResourceUrl | null = null;
  private readonly sanitizer = inject(DomSanitizer);

  ngOnInit() {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url);
  }
}
